exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-dialog-container {\n  /*max-width: 45vw;*/\n  min-width: 30vw;\n}\n\n.mry-dialog {}\n\nmd-dialog-actions {\n  text-align: right;\n  margin: 0!important;\n      padding: 12px 0 0 0!important;\n}\n\n.mry-dialog-close-button {\n  float: right;\n}\n\n.suspected-value-dialog {\n  width: 66vw;\n  height: 38vw;\n  .md-dialog-container {\n    .mry-dialog {\n      height: 100%;\n    }\n  };\n\n  md-dialog-actions{\n      \n  };\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/runner/work/admin-portal-2/admin-portal-2/~/css-loader?{"sourceMap":false,"importLoaders":1}!/home/runner/work/admin-portal-2/admin-portal-2/~/postcss-loader?{"ident":"postcss"}!/home/runner/work/admin-portal-2/admin-portal-2/src/app/core/dialog.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/app/core/dialog.scss
// module chunks = 9